import React, { useState, createRef, useEffect } from "react";
import CropperPlugin from "react-cropper";
import "cropperjs/dist/cropper.css";
import "./Cropper.css";
import { IoClose, IoCrop } from "react-icons/io5";

export const Cropper = (props) => {
	const [image, setImage] = useState(props.src);
	const [cropData, setCropData] = useState("#");
	const cropperRef = createRef();

	const getCropData = () => {
		if (typeof cropperRef.current?.cropper !== "undefined") {
			return cropperRef.current?.cropper.getCroppedCanvas().toDataURL(props.isPng ? "image/png" : "image/jpeg");
		}
		return null;
	};

	useEffect(() => {
		function handleKeyDown(event) {
			if (event.key === "Escape") {
				props.onCancel?.();
			}
		}
		window.addEventListener("keydown", handleKeyDown);
		return () => {
			window.removeEventListener("keydown", handleKeyDown);
		};
	}, [])

	return (
		<div className="cropper-wrapper">
			<CropperPlugin
				ref={cropperRef}
				style={{ width: "100%", aspectRatio: 1 / 1 }}
				zoomTo={0.5}
				initialAspectRatio={1}
				src={image}
				viewMode={1}
				minCropBoxHeight={10}
				minCropBoxWidth={10}
				background={false}
				responsive={true}
				autoCropArea={1}
				checkOrientation={false}
				guides={true}
			/>
			<div className="cropper-inline-controls">
				<button
					type="button"
					className="icon-button"
					onClick={(e) => props.onCancel?.()}
					title="Cancelar"
				>
					<IoClose />
					Cancelar
				</button>
				<button
					type="button"
					className="icon-button"
					onClick={() => props.onConfirm?.(getCropData())}
					title="Confirmar corte"
				>
					<IoCrop />
					Confirmar
				</button>
			</div>
		</div>
	);
};
